import { defineAsyncComponent } from 'vue';

const SAInvoiceDetail = defineAsyncComponent(() => import('@/views/sell/sAInvoice/SAInvoiceDetail.vue'));

const SASaleInvoiceDetail = defineAsyncComponent(() => import('@/views/invoice/saleInvoice/SASaleInvoiceDetail.vue'));
const ReceiptDetail = defineAsyncComponent(() => import('@/views/invoice/receipt/ReceiptDetail.vue'));
const AdjustSASaleInvoiceDetail = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/AdjustSASaleInvoiceDetail.vue')
);
const ReplacementSASaleInvoiceDetail = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/ReplacementSASaleInvoiceDetail.vue')
);
const CreateSaleVoucherPopup = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/CreateSaleVoucherPopup.vue')
);
const ConvertToPaperVoucherPopup = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/ConvertToPaperVoucherPopup.vue')
);

const SaleInvoiceReplacePopup = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/SaleInvoiceReplace.vue')
);
const CreateSaleVoucherMultiPopup = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/CreateSaleVoucherMultiPopup.vue')
);
const SASaleInvoiceGenDataPopup = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/SASaleInvoiceGenDataPopup.vue')
);
const ApproveVoucherSASaleInvoiceTab = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/ApproveVoucherSASaleInvoiceTab.vue')
);
const ApproveVoucherReceiptList = defineAsyncComponent(() =>
  import('@/views/invoice/receipt/ApproveVoucherReceiptList.vue')
);
const SAReturnDetail = defineAsyncComponent(() => import('@/views/sell/sAReturn/SAReturnDetail.vue'));
const ApproveVoucherSAReturnList = defineAsyncComponent(() =>
  import('@/views/sell/sAReturn/ApproveVoucherSAReturnList.vue')
);
const CAReceiptSaleUnitCapitalList = defineAsyncComponent(() =>
  import('@/views/sell/cAReceiptSale/CAReceiptSaleUnitCapitalList.vue')
);
const SettingEsign = defineAsyncComponent(() => import('@/views/invoice/setting_esign/SettingEsign.vue'));
const SettingEsignAllProject = defineAsyncComponent(() => import('@/views/invoice/setting_esign/SettingEsignAllProject.vue'));
const ReminderDebtEmail = defineAsyncComponent(() => import('@/views/sell/sAInvoice/ReminderDebtEmail.vue'));
const CertificatePopup = defineAsyncComponent(() => import('@/views/invoice/setting_esign/CertificatePopup.vue'));
const CertificateAllProjectPopup = defineAsyncComponent(() => import('@/views/invoice/setting_esign/CertificateAllProjectPopup.vue'));

const ESignNotiConnect = defineAsyncComponent(() => import('@/views/invoice/setting_esign/ESignNotiConnect.vue'));

const ESignUSB = defineAsyncComponent(() => import('@/views/invoice/setting_esign/ESignUSB.vue'));

const SelectCancelInvoiceForm = defineAsyncComponent(() =>
  import('@/views/invoice/cancelInvoice/popup/SelectCancelInvoiceForm.vue')
);
const CancellingInvoiceForm = defineAsyncComponent(() =>
  import('@/views/invoice/cancelInvoice/popup/CancellingInvoiceForm.vue')
);
const SendInvoiceCancellationNoticeToCustomers = defineAsyncComponent(() =>
  import('@/views/invoice/cancelInvoice/popup/SendInvoiceCancellationNoticeToCustomers.vue')
);
const SettingEmail = defineAsyncComponent(() => import('@/views/invoice/warning/SettingEmail.vue'));
const InstallDigitalSigningTool = defineAsyncComponent(() =>
  import('@/views/invoice/warning/InstallDigitalSigningTool.vue')
);
const EInvoiceAreOut = defineAsyncComponent(() => import('@/views/invoice/warning/EInvoiceAreOut.vue'));
const SendInBulk = defineAsyncComponent(() => import('@/views/invoice/sendInvoice/SendInBulk.vue'));
const MassReleaseForm = defineAsyncComponent(() => import('@/views/invoice/releaseInvoice/MassReleaseForm.vue'));
const ReleaseInvoiceForm = defineAsyncComponent(() => import('@/views/invoice/releaseInvoice/ReleaseInvoiceForm.vue'));
const DigitalSignatureConfirmationForm = defineAsyncComponent(() =>
  import('@/views/invoice/releaseInvoice/DigitalSignatureConfirmationForm.vue')
);
const ChooseDigitalCertificateForm = defineAsyncComponent(() =>
  import('@/views/invoice/releaseInvoice/ChooseDigitalCertificateForm.vue')
);

// Đăng ký component Chọn hóa đơn điều chỉnh: vqphong - 22.09.2022
const ChooseAdjustSaleInvoice = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/ChooseAdjustSaleInvoice.vue')
);

const OTPAuthorize = defineAsyncComponent(() => import('@/views/invoice/meInvoice/OTPAuthorize.vue'));

const MeInvoiceAgreement = defineAsyncComponent(() => import('@/views/invoice/meInvoice/MeInvoiceAgreement.vue'));
const StaticSaleInvoicePrintPreview = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoicePrintPreview/StaticSaleInvoicePrintPreview.vue')
);
const ReceiptPrintPreview = defineAsyncComponent(() =>
  import('@/views/invoice/receipt/ReceiptPrintPreview.vue')
);

const DVCFileDetailShowPreview = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/DVCFileDetailShowPreview.vue')
);

// const SelectCancelInvoiceForm = defineAsyncComponent(() =>
//   import('@/views/invoice/cancelInvoice/popup/SelectCancelInvoiceForm.vue')
// );
// const CancellingInvoiceForm = defineAsyncComponent(() =>
//   import('@/views/invoice/cancelInvoice/popup/CancellingInvoiceForm.vue')
// );
// const SendInvoiceCancellationNoticeToCustomers = defineAsyncComponent(() =>
//   import('@/views/invoice/cancelInvoice/popup/SendInvoiceCancellationNoticeToCustomers.vue')
// );
// const SettingEmail = defineAsyncComponent(() =>
//   import('@/views/invoice/warning/SettingEmail.vue')
// );
// const InstallDigitalSigningTool = defineAsyncComponent(() =>
//   import('@/views/invoice/warning/InstallDigitalSigningTool.vue')
// );
// const EInvoiceAreOut = defineAsyncComponent(() =>
//   import('@/views/invoice/warning/EInvoiceAreOut.vue')
// );
// const SendInBulk = defineAsyncComponent(() =>
//   import('@/views/invoice/sendInvoice/SendInBulk.vue')
// );
// const MassReleaseForm = defineAsyncComponent(() =>
//   import('@/views/invoice/releaseInvoice/MassReleaseForm.vue')
// );
// const ReleaseInvoiceForm = defineAsyncComponent(() =>
//   import('@/views/invoice/releaseInvoice/ReleaseInvoiceForm.vue')
// );
// const DigitalSignatureConfirmationForm = defineAsyncComponent(() =>
//   import('@/views/invoice/releaseInvoice/DigitalSignatureConfirmationForm.vue')
// );
// const ChooseDigitalCertificateForm = defineAsyncComponent(() =>
//   import('@/views/invoice/releaseInvoice/ChooseDigitalCertificateForm.vue')
// );

const GetReceiptDataPopup = defineAsyncComponent(() =>
  import('@/views/invoice/receipt/GetReceiptPopup.vue')
);
const GenerateReceiptDataMultiPopup = defineAsyncComponent(() =>
  import('@/views/invoice/receipt/GenerateReceiptDataMultiPopup.vue')
);
const ConfirmConnectMeinvoicePopup = defineAsyncComponent(() =>
  import('@/views/invoice/processInvoice/ConfirmConnectMeinvoicePopup.vue')
);

///Vé điện tử
const ElectronicTicketDetail = defineAsyncComponent(() => import('@/views/invoice/electronicTicket/ElectronicTicketDetail.vue'));
const ApproveElectronicTicketList = defineAsyncComponent(() =>
  import('@/views/invoice/electronicTicket/ApproveElectronicTicketList.vue')
);
const GenerateTicketPopup = defineAsyncComponent(() =>
  import('@/views/invoice/electronicTicket/GenerateTicketPopup.vue')
);
const GetElectronicTicketDataPopup = defineAsyncComponent(() =>
  import('@/views/invoice/electronicTicket/GetElectronicTicketPopup.vue')
);
const ViewDebtInvoiceACTPopup = defineAsyncComponent(() =>
  import('@/views/debtInvoiceACT/ViewDebtInvoiceACTPopup.vue')
);
const GenerateDebtInvoicePopup = defineAsyncComponent(() =>
  import('@/views/debtInvoiceACT/GenerateDebtInvoicePopup.vue')
);
// Thông báo đã xuất hóa đơn tài chính
const FinancialInvoiceNotiPopup = defineAsyncComponent(() =>
  import('@/views/debtInvoiceACT/FinancialInvoiceNotiPopup.vue')
);
// Thông báo từ hệ thống
const NotiSystemPopup = defineAsyncComponent(() =>
  import('@/views/debtInvoiceACT/NotiSystemPopup.vue')
);
// Popup chọn khoảng thời gian
const ChoosePeriodTimePopup = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/ChoosePeriodTimePopup.vue')
);
// Popup show kết quả sinh chứng từ bán hàng (NHANH3 21.05.2024)
const CreateSaleVoucherResult = defineAsyncComponent(() => import('@/views/invoice/saleInvoice/CreateSaleVoucherResult.vue'))

export function registerSA(app) {
  app.component('SAInvoiceDetail', SAInvoiceDetail);
  app.component('SAReturnDetail', SAReturnDetail);
  app.component('SASaleInvoiceDetail', SASaleInvoiceDetail);
  app.component('ReceiptDetail', ReceiptDetail);
  app.component('AdjustSASaleInvoiceDetail', AdjustSASaleInvoiceDetail);
  app.component('ReplacementSASaleInvoiceDetail', ReplacementSASaleInvoiceDetail);
  app.component('CreateSaleVoucherPopup', CreateSaleVoucherPopup);
  app.component('ConvertToPaperVoucherPopup', ConvertToPaperVoucherPopup);
  app.component('SaleInvoiceReplacePopup', SaleInvoiceReplacePopup);
  app.component('CreateSaleVoucherMultiPopup', CreateSaleVoucherMultiPopup);
  app.component('SASaleInvoiceGenDataPopup', SASaleInvoiceGenDataPopup);
  app.component('ApproveVoucherSASaleInvoiceTab', ApproveVoucherSASaleInvoiceTab);
  app.component('ApproveVoucherReceiptList', ApproveVoucherReceiptList);
  app.component('ApproveVoucherSAReturnList', ApproveVoucherSAReturnList);
  app.component('CAReceiptSaleUnitCapitalList', CAReceiptSaleUnitCapitalList);

  // Đăng ký component Chọn hóa đơn điều chỉnh: vqphong - 22.09.2022
  app.component('ChooseAdjustSaleInvoice', ChooseAdjustSaleInvoice);

  app.component('SettingEsign', SettingEsign);
  app.component('SettingEsignAllProject', SettingEsignAllProject);
  app.component('ReminderDebtEmail', ReminderDebtEmail);
  app.component('CertificatePopup', CertificatePopup);
  app.component('CertificateAllProjectPopup', CertificateAllProjectPopup);
  app.component('ESignNotiConnect', ESignNotiConnect);
  app.component('ESignUSB', ESignUSB);
  app.component('StaticSaleInvoicePrintPreview', StaticSaleInvoicePrintPreview);
  app.component('ReceiptPrintPreview', ReceiptPrintPreview);
  app.component('DVCFileDetailShowPreview', DVCFileDetailShowPreview);

  app.component('SelectCancelInvoiceForm', SelectCancelInvoiceForm);
  app.component('CancellingInvoiceForm', CancellingInvoiceForm);
  app.component('SendInvoiceCancellationNoticeToCustomers', SendInvoiceCancellationNoticeToCustomers);
  app.component('SettingEmail', SettingEmail);
  app.component('InstallDigitalSigningTool', InstallDigitalSigningTool);
  app.component('EInvoiceAreOut', EInvoiceAreOut);
  app.component('SendInBulk', SendInBulk);
  app.component('MassReleaseForm', MassReleaseForm);
  app.component('ReleaseInvoiceForm', ReleaseInvoiceForm);
  app.component('DigitalSignatureConfirmationForm', DigitalSignatureConfirmationForm);
  app.component('ChooseDigitalCertificateForm', ChooseDigitalCertificateForm);

  app.component('OTPAuthorize', OTPAuthorize);
  app.component('MeInvoiceAgreement', MeInvoiceAgreement);
  app.component('GetReceiptDataPopup', GetReceiptDataPopup);
  app.component('GenerateReceiptDataMultiPopup', GenerateReceiptDataMultiPopup);
  app.component('ConfirmConnectMeinvoicePopup', ConfirmConnectMeinvoicePopup);
  app.component('ElectronicTicketDetail', ElectronicTicketDetail);
  app.component('ApproveElectronicTicketList', ApproveElectronicTicketList);
  app.component('GenerateTicketPopup', GenerateTicketPopup);
  app.component('GetElectronicTicketDataPopup', GetElectronicTicketDataPopup);
  app.component('ViewDebtInvoiceACTPopup', ViewDebtInvoiceACTPopup);
  app.component('GenerateDebtInvoicePopup', GenerateDebtInvoicePopup);
  app.component('FinancialInvoiceNotiPopup', FinancialInvoiceNotiPopup);
  app.component('NotiSystemPopup', NotiSystemPopup);
  app.component('ChoosePeriodTimePopup', ChoosePeriodTimePopup);
  app.component('CreateSaleVoucherResult', CreateSaleVoucherResult);
}
